import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import TabNavItem from '../common/tabs/TabNavItem';
import TabContent from '../common/tabs/TabContent';
import CampaignTable from './CampaignTable';
import CampaignTemplateTable from './CampaignTemplateTable';

function CampaignTabContainer() {
    const [activeTab, setActiveTab] = useState('campaign-list-tab');
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);

    return (
        <Card className="card-padding shadow-sm border-0">
            <Card.Body className="p-3">
                <div className="d-flex align-items-center justify-content-between gap-2 mb-3 nav-tabs-bordered">
                    <ul className="nav nav-tabs flex-grow-1 mb-0 border-0">
                        <TabNavItem
                            id="campaign-list-tab"
                            title="Campaign List"
                            icon="bi bi-table"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                        <TabNavItem
                            id="template-tab"
                            title="Template"
                            icon="bi bi-card-heading"
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    </ul>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm flex-shrink-0"
                        onClick={() => setSearchPanelOpen((open) => !open)}
                        aria-expanded={searchPanelOpen}
                        title={searchPanelOpen ? 'Hide filters' : 'Show filters'}
                    >
                        <i className="bi bi-funnel me-1"></i>
                        Filter
                    </button>
                </div>
                <div className="tab-content">
                    <TabContent id="campaign-list-tab" activeTab={activeTab}>
                        <CampaignTable searchPanelOpen={searchPanelOpen} />
                    </TabContent>
                    <TabContent id="template-tab" activeTab={activeTab}>
                        <CampaignTemplateTable searchPanelOpen={searchPanelOpen} />
                    </TabContent>
                </div>
            </Card.Body>
        </Card>
    );
}

export default CampaignTabContainer;
